import moment from "moment";

const setTime = (date, time) =>
  moment(date).set({
    hour: time.get("hour"),
    minute: time.get("minute")
  });

const isWeekday = date => {
  const day = date.day();
  return day !== 0 && day !== 6;
};

const isWeekend = date => {
  const day = date.day();
  return day === 0 || day === 6;
};

const isSunday = date => {
  const day = date.day();
  return day === 0;
};
export { setTime , isWeekday, isWeekend, isSunday};



// WEBPACK FOOTER //
// ./src/utils/DateHelpers.js